import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const buttonV3PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate button external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'button'>): void => {
    const offset = props.style?.button?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
